import React, { useState } from 'react';
import { ChevronDown, ChevronRight, Calculator, Scissors } from 'lucide-react';
import MathPanel from './MathPanel';
import CutManager from './CutManager';

const RightSidebar: React.FC = () => {
  // Allow multiple sections to be expanded simultaneously
  const [expandedSections, setExpandedSections] = useState<Record<string, boolean>>({
    math: true,
    cuts: true
  });

  const toggle = (sec: string) => {
    setExpandedSections(prev => ({
      ...prev,
      [sec]: !prev[sec]
    }));
  };

  return (
    <div className="w-96 h-full bg-slate-900/95 border-l border-white/10 flex flex-col backdrop-blur-md pointer-events-auto text-[13px] leading-5">

      {/* 1. Problem Formulation */}
      <div className="flex flex-col border-b border-white/10">
        <button
          onClick={() => toggle('math')}
          className="flex items-center justify-between px-4 py-3 hover:bg-white/5 transition-colors text-sm font-bold tracking-wider text-sky-400"
        >
          <div className="flex items-center gap-2">
            <Calculator size={14} />
            <span>Problem Formulation</span>
          </div>
          {expandedSections['math'] ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        </button>

        {expandedSections['math'] && (
          <div className="p-4 bg-black/20 overflow-y-auto max-h-[44vh]">
            <MathPanel embedded />
          </div>
        )}
      </div>

      {/* 2. Cutting Planes */}
      <div className="flex flex-col flex-1 min-h-0">
        <button
          onClick={() => toggle('cuts')}
          className="flex items-center justify-between px-4 py-3 hover:bg-white/5 transition-colors text-sm font-bold tracking-wider text-sky-400 border-b border-white/10"
        >
          <div className="flex items-center gap-2">
            <Scissors size={14} />
            <span>Cutting Planes</span>
          </div>
          {expandedSections['cuts'] ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        </button>

        {expandedSections['cuts'] && (
          <div className="p-4 bg-black/20 flex-1 overflow-y-auto custom-scrollbar">
            <CutManager />
          </div>
        )}
      </div>
    </div>
  );
};

export default RightSidebar;
